import { defineComponent, h, useAttrs } from 'vue'
import { VCard } from 'vuetify/components'
import { hasBooleanishAttr } from './legacyInputProps'

function resolveVariant(attrs) {
  if (attrs.variant != null) return attrs.variant
  if (hasBooleanishAttr(attrs.outlined)) return 'outlined'
  if (hasBooleanishAttr(attrs.flat)) return 'flat'
  if (hasBooleanishAttr(attrs.raised)) return 'elevated'
  return undefined
}

function normalizeAttrs(attrs) {
  const normalized = { ...attrs }
  const variant = resolveVariant(attrs)

  if (variant) normalized.variant = variant
  if (hasBooleanishAttr(attrs.tile)) normalized.rounded = '0'
  normalized.class = ['v-sheet', attrs.class]

  delete normalized.outlined
  delete normalized.flat
  delete normalized.raised
  delete normalized.tile

  return normalized
}

export default defineComponent({
  name: 'VCardCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  setup(_, { slots }) {
    const attrs = useAttrs()

    return () => h(VCard, normalizeAttrs(attrs), slots)
  }
})
